/* Club Explorador — theme.js
   Navegación móvil, galería del héroe, anatomía del pack, biblioteca, reseñas, cajón de la mochila (cart drawer) con AJAX y selectores de cantidad.
   Sense dependències externes. */
(function () {
  'use strict';

  // Text d'un preu o d'un botó copiat d'un altre element: espais simples, però amb un espai no separable abans del €
  // perquè el preu no es parteixi en dues línies («29,95» / «€») quan el botó no cap en una línia.
  function cleanText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim().replace(/(\d) (?=€)/g, '$1\u00A0');
  }

  // Formulari de dins d'un diàleg: en obrir-lo, el focus va al títol (no a la X, que WebKit marcava amb l'anell blau).
  function focusDialogTitle(dialog) {
    var title = dialog && dialog.querySelector('.reviews-modal__title[tabindex]');
    if (title && title.offsetParent !== null) title.focus({ preventScroll: true });
  }

  /* ---------------- Mobile nav ---------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-mobile-nav-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* ---------------- Hero gallery (carrusel) ---------------- */
  var HeroGallery = {
    ticking: false,

    behavior: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    },

    goTo: function (gallery, index, behavior) {
      var track = gallery.querySelector('[data-gallery-track]');
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      if (!track || !slides.length || !track.clientWidth) return;
      index = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: index * track.clientWidth, behavior: behavior || this.behavior() });
    },

    update: function (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      if (!track || !slides.length || !track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth) || 0;
      index = Math.max(0, Math.min(index, slides.length - 1));

      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        var active = parseInt(thumb.dataset.galleryThumb, 10) === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      gallery.dataset.galleryIndex = index;
    },

    current: function (gallery) {
      return parseInt(gallery.dataset.galleryIndex, 10) || 0;
    },

    init: function () {
      var self = this;

      document.addEventListener('click', function (event) {
        var gallery = event.target.closest('[data-hero-gallery]');
        if (!gallery) return;
        var thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb) return self.goTo(gallery, parseInt(thumb.dataset.galleryThumb, 10));
        if (event.target.closest('[data-gallery-prev]')) return self.goTo(gallery, self.current(gallery) - 1);
        if (event.target.closest('[data-gallery-next]')) return self.goTo(gallery, self.current(gallery) + 1);
      });

      document.addEventListener('scroll', function (event) {
        var track = event.target;
        if (!track || !track.matches || !track.matches('[data-gallery-track]') || self.ticking) return;
        self.ticking = true;
        window.requestAnimationFrame(function () {
          self.ticking = false;
          var gallery = track.closest('[data-hero-gallery]');
          if (gallery) self.update(gallery);
        });
      }, true);

      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-hero-gallery]').forEach(function (gallery) {
          self.goTo(gallery, self.current(gallery));
          self.update(gallery);
        });
      });

      document.addEventListener('shopify:block:select', function (event) {
        var gallery = event.target.closest && event.target.closest('[data-hero-gallery]');
        var slides = gallery && Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
        if (slides && slides.indexOf(event.target) > -1) self.goTo(gallery, slides.indexOf(event.target));
      });
    },
  };
  HeroGallery.init();

  /* ---------------- Pack switcher (Pack Esencial / Caja Explorador) ---------------- */
  var PackSwitcher = {
    select: function (root, key, options) {
      options = options || {};
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pack-tab]'));
      var active = tabs.filter(function (tab) { return tab.dataset.packTab === key; })[0];
      if (!active || (root.dataset.activePack === key && !options.force)) return;

      tabs.forEach(function (tab) {
        var on = tab === active;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-checked', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      root.querySelectorAll('[data-pack-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.packPanel !== key;
      });
      root.dataset.activePack = key;
      if (options.animate !== false) {
        var section = root.closest('.hero-pack');
        if (section) section.classList.add('is-switched');
      }

      var gallery = root.querySelector('[data-hero-gallery][data-pack-panel="' + key + '"]');
      if (gallery) {
        HeroGallery.goTo(gallery, 0, 'auto');
        HeroGallery.update(gallery);
      }
      if (options.focus) active.focus();

      root.dispatchEvent(new CustomEvent('pack:change', {
        bubbles: true,
        detail: {
          key: key,
          productHandle: active.dataset.productHandle || null,
          variantId: active.dataset.variantId || null,
        },
      }));
    },

    init: function () {
      var self = this;

      document.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-pack-tab]');
        var root = tab && tab.closest('[data-pack-switcher]');
        if (root) self.select(root, tab.dataset.packTab);
      });

      document.addEventListener('keydown', function (event) {
        var tab = event.target.closest && event.target.closest('[data-pack-tab]');
        var root = tab && tab.closest('[data-pack-switcher]');
        if (!root) return;
        var keys = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pack-tab]'));
        var next = tabs[(tabs.indexOf(tab) + keys[event.key] + tabs.length) % tabs.length];
        self.select(root, next.dataset.packTab, { focus: true });
      });

      // Editor de temes: en seleccionar una opció o una imatge, mostra el pack corresponent.
      document.addEventListener('shopify:block:select', function (event) {
        var target = event.target;
        var root = target.closest && target.closest('[data-pack-switcher]');
        if (!root) return;
        var panel = target.closest('[data-pack-panel]');
        var key = target.dataset.packTab || (panel && panel.dataset.packPanel);
        if (key) self.select(root, key, { animate: false });
        var gallery = target.closest('[data-hero-gallery]');
        if (gallery && target.hasAttribute('data-gallery-slide')) {
          var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
          HeroGallery.goTo(gallery, slides.indexOf(target), 'auto');
        }
      });
    },
  };
  PackSwitcher.init();

  /* ---------------- Anatomía del pack: timeline, visual lateral i vista previa ---------------- */
  var PackAnatomy = {
    // With a key: that pack's hero button (even if another option is selected in the hero). Without: the visible one.
    heroCta: function (key) {
      if (key) {
        var own = document.querySelector('[data-pack-switcher] .hero-pack__cta[data-pack-panel="' + key + '"] .btn');
        if (own) return own;
      }
      return document.querySelector('[data-pack-switcher] .hero-pack__cta:not([hidden]) .btn');
    },

    // Pack currently shown by the Anatomy section.
    anatomyPack: function () {
      var root = document.querySelector('[data-pack-anatomy]');
      return (root && root.dataset.activePack) || null;
    },

    activePack: function () {
      var hero = document.querySelector('[data-pack-switcher]');
      return (hero && hero.dataset.activePack) || 'essential';
    },

    // Same label, price and behaviour as the hero button (which follows Pack Esencial / Caja Explorador).
    syncCta: function (scope, key) {
      var btn = this.heroCta(key);
      var label = btn && cleanText(btn.textContent);
      if (!label) return;
      (scope || document).querySelectorAll(scope ? '[data-pack-cta-label]' : '[data-pack-anatomy] [data-pack-cta-label]').forEach(function (el) {
        el.textContent = label;
      });
    },

    setPack: function (key, animate) {
      // Only packs that exist in this section (e.g. "Solo el libro" has no tab here): otherwise keep the current one.
      if (!document.querySelector('[data-pack-anatomy] [data-anatomy-tab="' + key + '"]')) return;
      document.querySelectorAll('[data-pack-anatomy]').forEach(function (root) {
        root.dataset.activePack = key;
        if (animate) root.classList.add('is-switched');
        root.querySelectorAll('[data-anatomy-tab]').forEach(function (tab) {
          var on = tab.dataset.anatomyTab === key;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-checked', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
      });
      this.syncCta(null, key);
    },

    // Tab names and the yellow badge are copied from the hero selector (single source of truth).
    syncTabs: function () {
      document.querySelectorAll('[data-pack-anatomy] [data-anatomy-tab]').forEach(function (tab) {
        var heroTab = document.querySelector('[data-pack-switcher] [data-pack-tab="' + tab.dataset.anatomyTab + '"]');
        if (!heroTab) return;
        var heroLabel = heroTab.querySelector('.hero-pack__tab-label');
        var label = tab.querySelector('.pack-tab__label');
        if (heroLabel && label) label.textContent = heroLabel.textContent.trim();
        if (tab.classList.contains('pack-tab--static')) return; // single fixed block: name only, no badge
        var heroBadge = heroTab.querySelector('.hero-pack__tab-badge');
        var badge = tab.querySelector('.pack-tab__badge');
        if (!heroBadge) {
          if (badge) badge.remove();
          return;
        }
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'pack-tab__badge';
          tab.insertBefore(badge, tab.firstChild);
        }
        badge.innerHTML = heroBadge.innerHTML;
      });
    },

    // Choosing a pack here drives the hero selector, which emits pack:change and updates everything.
    choose: function (key) {
      var hero = document.querySelector('[data-pack-switcher]');
      if (hero) PackSwitcher.select(hero, key);
      else this.setPack(key, true);
    },

    setActiveStep: function (root, n) {
      root.querySelectorAll('[data-pack-step]').forEach(function (step) {
        step.classList.toggle('is-active', step.dataset.packStep === String(n));
      });
      root.querySelectorAll('[data-pack-visual]').forEach(function (layer) {
        layer.classList.toggle('is-active', layer.dataset.packVisual === String(n));
      });
    },

    // Picks the resource closest to the reading line (robust to instant jumps such as anchor links).
    observe: function (root) {
      var self = this;
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pack-step]'));
      var ticking = false;
      function update() {
        ticking = false;
        var box = root.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        var line = window.innerHeight * 0.38;
        var best = null;
        var bestDistance = Infinity;
        steps.forEach(function (step) {
          if (!step.offsetParent) return;
          var distance = Math.abs(step.getBoundingClientRect().top + 40 - line);
          if (distance < bestDistance) { bestDistance = distance; best = step; }
        });
        if (best) self.setActiveStep(root, best.dataset.packStep);
      }
      function schedule() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    },

    // Also used by the hero ("Previsualizar el libro"): its template sits in a [data-pack-preview-scope] wrapper.
    open: function (root, trigger) {
      var fromHero = !trigger.closest('[data-pack-anatomy]');
      var step = trigger.closest('.pack-step, [data-pack-preview-scope]');
      var tpl = step && step.querySelector('template[data-pack-preview-template]');
      // Hero "Solo el libro": reuse the book pages uploaded in the Anatomy section.
      if (!tpl && trigger.dataset.previewSource) {
        tpl = root.querySelector('template[data-pack-preview-template][data-preview-icon="' + trigger.dataset.previewSource + '"]');
      }
      var dialog = root._packModal || root.querySelector('[data-pack-modal]');
      if (!tpl || !dialog || typeof dialog.showModal !== 'function') return;
      var stage = dialog.querySelector('[data-pack-modal-pages]');
      stage.innerHTML = '';
      stage.appendChild(tpl.content.cloneNode(true));
      dialog._pages = Array.prototype.slice.call(stage.children);
      dialog._index = 0;
      dialog.dataset.kind = tpl.dataset.kind || 'pages';
      dialog.querySelector('[data-pack-modal-title]').textContent = trigger.dataset.title || '';
      this.render(dialog);
      // From the hero the modal button follows the hero choice; from Anatomy it follows the pack shown there.
      var ctaPack = fromHero ? this.activePack() : (root.dataset.activePack || this.activePack());
      dialog.dataset.ctaPack = ctaPack;
      // The dialog lives in <body> (moved there on init), so its own button is always refreshed explicitly.
      this.syncCta(dialog, ctaPack);
      if (!fromHero) this.syncCta(null, ctaPack);
      dialog._scrollY = window.pageYOffset;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.keepScroll(dialog._scrollY);
    },

    // Opening/closing a dialog must leave the page exactly where it was (focus moves can scroll in some browsers).
    keepScroll: function (y) {
      if (typeof y !== 'number' || Math.abs(window.pageYOffset - y) < 2) return;
      var html = document.documentElement;
      var previous = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      html.style.scrollBehavior = previous;
    },

    render: function (dialog) {
      var pages = dialog._pages || [];
      var i = dialog._index;
      var audio = dialog.dataset.kind === 'audio';
      pages.forEach(function (page, k) { page.hidden = k !== i; });
      var prev = dialog.querySelector('[data-pack-modal-prev]');
      var next = dialog.querySelector('[data-pack-modal-next]');
      var counter = dialog.querySelector('[data-pack-modal-counter]');
      prev.hidden = next.hidden = audio || pages.length < 2;
      prev.disabled = i === 0;
      next.disabled = i >= pages.length - 1;
      counter.textContent = audio ? '' : (i + 1) + ' / ' + pages.length;
    },

    cleanup: function (dialog) {
      if (!document.querySelector('dialog[open]')) document.body.style.overflow = '';
      var stage = dialog.querySelector('[data-pack-modal-pages]');
      if (stage) stage.innerHTML = '';
      this.keepScroll(dialog._scrollY);
    },

    closeModal: function (dialog) {
      if (dialog.open) dialog.close();
      this.cleanup(dialog);
    },

    go: function (dialog, delta) {
      var pages = dialog._pages || [];
      dialog._index = Math.max(0, Math.min(dialog._index + delta, pages.length - 1));
      this.render(dialog);
    },

    init: function () {
      var self = this;
      var roots = document.querySelectorAll('[data-pack-anatomy]');
      if (!roots.length) return;

      roots.forEach(function (root) {
        self.observe(root);
        var dialog = root.querySelector('[data-pack-modal]');
        if (dialog) {
          // Live at <body> level: opening it from the hero must not pull the page (or the theme editor) to the Anatomy section.
          root._packModal = dialog;
          document.body.appendChild(dialog);
          dialog.addEventListener('click', function (event) { if (event.target === dialog) self.closeModal(dialog); });
          dialog.addEventListener('close', function () { self.cleanup(dialog); });
        }
      });
      this.syncTabs();
      this.setPack(this.activePack(), false);
      this.syncCta(null, this.anatomyPack());

      document.addEventListener('pack:change', function (event) {
        self.setPack(event.detail.key, true);
      });

      document.addEventListener('click', function (event) {
        var packTab = event.target.closest('[data-anatomy-tab]:not(.pack-tab--static)');
        if (packTab) {
          self.choose(packTab.dataset.anatomyTab);
          return;
        }
        var trigger = event.target.closest('[data-pack-preview]');
        if (trigger) {
          var root = trigger.closest('[data-pack-anatomy]') || document.querySelector('[data-pack-anatomy]');
          if (root) self.open(root, trigger);
          return;
        }
        var dialog = event.target.closest('[data-pack-modal]');
        if (dialog) {
          if (event.target.closest('[data-pack-modal-close]')) self.closeModal(dialog);
          else if (event.target.closest('[data-pack-modal-prev]')) self.go(dialog, -1);
          else if (event.target.closest('[data-pack-modal-next]')) self.go(dialog, 1);
        }
        var cta = event.target.closest('[data-pack-cta]');
        if (cta) {
          var parent = cta.closest('[data-pack-modal]');
          if (parent) self.closeModal(parent);
          // Modal: the pack it was opened for. Anatomy: the pack it shows. Header / final CTA: the hero's current choice.
          var ctaKey = parent ? parent.dataset.ctaPack : (cta.dataset.ctaPack || (cta.closest('[data-pack-anatomy]') ? self.anatomyPack() : null));
          var heroButton = self.heroCta(ctaKey);
          if (heroButton) heroButton.click();
          else if (cta.dataset.fallbackHref) window.location.href = cta.dataset.fallbackHref;
        }
      });

      document.addEventListener('keydown', function (event) {
        var packTab = event.target.closest && event.target.closest('[data-anatomy-tab]');
        if (packTab) {
          var steps = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 };
          if (!(event.key in steps)) return;
          event.preventDefault();
          var tabs = Array.prototype.slice.call(packTab.parentNode.querySelectorAll('[data-anatomy-tab]'));
          var next = tabs[(tabs.indexOf(packTab) + steps[event.key] + tabs.length) % tabs.length];
          self.choose(next.dataset.anatomyTab);
          next.focus();
          return;
        }
        var dialog = document.querySelector('[data-pack-modal][open]');
        if (!dialog) return;
        if (event.key === 'ArrowLeft') self.go(dialog, -1);
        if (event.key === 'ArrowRight') self.go(dialog, 1);
      });

      // Editor de temes: en seleccionar un recurs, l'activa a la línia de temps.
      document.addEventListener('shopify:block:select', function (event) {
        var step = event.target.closest && event.target.closest('[data-pack-step]');
        var root = step && step.closest('[data-pack-anatomy]');
        if (root) self.setActiveStep(root, step.dataset.packStep);
      });
    },
  };
  PackAnatomy.init();

  /* ---------------- Biblioteca Club Explorador: carrusel de recursos ---------------- */
  var LibraryShelf = {
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },

    update: function (root) {
      var track = root.querySelector('[data-library-track]');
      var viewport = root.querySelector('[data-library-viewport]');
      if (!track || !viewport) return;
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= max - 4;
      viewport.classList.toggle('is-scrolled', !atStart);
      viewport.classList.toggle('is-end', atEnd);
      var prev = root.querySelector('[data-library-prev]');
      var next = root.querySelector('[data-library-next]');
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    },

    step: function (root, direction) {
      var track = root.querySelector('[data-library-track]');
      var card = track && track.querySelector('.library-card');
      if (!card) return;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 20;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.reduced() ? 'auto' : 'smooth' });
    },

    // Same price as the Pack Esencial in the hero.
    syncPrice: function (root) {
      var el = root.querySelector('[data-library-price]');
      var heroPrice = document.querySelector('[data-pack-switcher] .hero-pack__panel[data-pack-panel="essential"] .price--lg');
      var price = heroPrice && cleanText(heroPrice.textContent);
      if (el && price && el.dataset.template) el.textContent = el.dataset.template.replace('{price}', price);
    },

    init: function () {
      var self = this;
      var roots = document.querySelectorAll('[data-library]');
      if (!roots.length) return;

      roots.forEach(function (root) {
        self.update(root);
        self.syncPrice(root);
      });

      document.addEventListener('click', function (event) {
        var root = event.target.closest('[data-library]');
        if (!root) return;
        if (event.target.closest('[data-library-prev]')) return self.step(root, -1);
        if (event.target.closest('[data-library-next]')) return self.step(root, 1);
        var cta = event.target.closest('[data-library-pack-cta]');
        var hero = cta && document.querySelector('.hero-pack');
        if (hero) {
          event.preventDefault();
          // The library always leads to the complete pack: select it in the hero before scrolling up.
          var switcher = hero.querySelector('[data-pack-switcher]');
          if (switcher && switcher.querySelector('[data-pack-tab="essential"]')) PackSwitcher.select(switcher, 'essential');
          var header = document.querySelector('.site-header');
          window.scrollTo({ top: Math.max(0, hero.getBoundingClientRect().top + window.pageYOffset - (header ? header.offsetHeight : 0)), behavior: self.reduced() ? 'auto' : 'smooth' });
        }
      });

      var ticking = false;
      document.addEventListener('scroll', function (event) {
        var track = event.target;
        if (!track || !track.matches || !track.matches('[data-library-track]') || ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var root = track.closest('[data-library]');
          if (root) self.update(root);
        });
      }, true);

      window.addEventListener('resize', function () {
        roots.forEach(function (root) { self.update(root); });
      });

      // Editor de temes: en seleccionar un recurs, l'enfoca al carrusel.
      document.addEventListener('shopify:block:select', function (event) {
        var card = event.target.closest && event.target.closest('.library-card');
        if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      });
    },
  };
  LibraryShelf.init();

  /* ---------------- Reseñas: carrusel, "ver todas", formulario y lightbox ---------------- */
  var Reviews = {
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },

    update: function (root) {
      var track = root.querySelector('[data-reviews-track]');
      var viewport = root.querySelector('[data-reviews-viewport]');
      if (!track || !viewport) return;
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= max - 4;
      viewport.classList.toggle('is-scrolled', !atStart);
      viewport.classList.toggle('is-end', atEnd);
      var prev = root.querySelector('[data-reviews-prev]');
      var next = root.querySelector('[data-reviews-next]');
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    },

    step: function (root, direction) {
      var track = root.querySelector('[data-reviews-track]');
      var card = track && track.querySelector('.review-card');
      if (!card) return;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 20;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.reduced() ? 'auto' : 'smooth' });
    },

    toggleAll: function (root, button) {
      var all = root.querySelector('[data-reviews-all]');
      if (!all) return;
      var open = all.hidden;
      all.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = button.querySelector('[data-reviews-toggle-label]');
      if (label) label.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;
      if (!open) {
        var top = root.getBoundingClientRect().top;
        if (top < 0) window.scrollTo({ top: window.pageYOffset + top - 80, behavior: this.reduced() ? 'auto' : 'smooth' });
      }
    },

    loadMore: function (root, button) {
      var hidden = Array.prototype.slice.call(root.querySelectorAll('.review-row[hidden]'));
      hidden.slice(0, 6).forEach(function (row) { row.hidden = false; });
      if (hidden.length <= 6) button.hidden = true;
    },

    /* ---- write a review ---- */
    // Enllaç de «reseña tras la compra»: ?write_review=1&review_order=1234&review_token=...
    // Es reenvien amb la ressenya perquè el procés de verificació (app / automatització) la pugui enllaçar a la comanda.
    linkParams: function () {
      var params = new URLSearchParams(window.location.search);
      return { open: params.has('write_review'), order: params.get('review_order') || '', token: params.get('review_token') || '' };
    },

    openForm: function (root) {
      var dialog = root.querySelector('[data-reviews-modal]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var link = this.linkParams();
      var order = dialog.querySelector('[data-reviews-order]');
      var token = dialog.querySelector('[data-reviews-token]');
      var origin = dialog.querySelector('[data-reviews-origin]');
      if (order) order.value = link.order;
      if (token) token.value = link.token;
      if (origin) origin.value = (link.order || link.token) ? 'enlace post-compra' : 'web';
      var wrap = dialog.querySelector('[data-reviews-form-wrap]');
      var thanks = dialog.querySelector('[data-reviews-thanks]');
      var error = dialog.querySelector('[data-reviews-error]');
      if (wrap) wrap.hidden = false;
      if (thanks) thanks.hidden = true;
      if (error) error.hidden = true;
      dialog.showModal();
      focusDialogTitle(dialog);
      document.body.style.overflow = 'hidden';
    },

    closeDialog: function (dialog) {
      if (dialog.open) dialog.close();
      document.body.style.overflow = '';
      var stage = dialog.querySelector('[data-review-lightbox-stage]');
      if (stage) stage.innerHTML = '';
    },

    renderFiles: function (dialog) {
      var list = dialog.querySelector('[data-reviews-files]');
      if (!list) return;
      var files = dialog._files || [];
      var self = this;
      list.innerHTML = '';
      files.forEach(function (file, index) {
        var li = document.createElement('li');
        var thumb;
        if (file.type.indexOf('image/') === 0) {
          thumb = document.createElement('img');
          thumb.alt = '';
          thumb.src = URL.createObjectURL(file);
        } else {
          thumb = document.createElement('span');
          thumb.className = 'reviews-files__icon';
          thumb.textContent = '▶';
        }
        var name = document.createElement('span');
        name.className = 'reviews-files__name';
        name.textContent = file.name;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = dialog.dataset.msgRemove || 'Quitar';
        remove.addEventListener('click', function () {
          files.splice(index, 1);
          self.syncInput(dialog);
          self.renderFiles(dialog);
        });
        li.appendChild(thumb);
        li.appendChild(name);
        li.appendChild(remove);
        list.appendChild(li);
      });
    },

    syncInput: function (dialog) {
      var input = dialog.querySelector('[data-reviews-file]');
      if (!input || typeof DataTransfer === 'undefined') return;
      var transfer = new DataTransfer();
      (dialog._files || []).forEach(function (file) { transfer.items.add(file); });
      input.files = transfer.files;
    },

    onFiles: function (dialog, input) {
      var maxMb = parseFloat(dialog.dataset.maxMb) || 25;
      var maxFiles = parseInt(dialog.dataset.maxFiles, 10) || 3;
      var error = dialog.querySelector('[data-reviews-error]');
      var files = dialog._files || (dialog._files = []);
      var problem = '';
      Array.prototype.slice.call(input.files).forEach(function (file) {
        if (files.length >= maxFiles) { problem = (dialog.dataset.msgFileLimit || '').replace('%COUNT%', maxFiles); return; }
        if (file.size > maxMb * 1024 * 1024) { problem = (dialog.dataset.msgFileTooBig || '').replace('%NAME%', file.name).replace('%MB%', maxMb); return; }
        files.push(file);
      });
      this.syncInput(dialog);
      this.renderFiles(dialog);
      if (error) {
        error.textContent = problem || dialog.dataset.msgError || '';
        error.hidden = !problem;
      }
    },

    showThanks: function (dialog, form) {
      form.reset();
      dialog._files = [];
      this.renderFiles(dialog);
      dialog.querySelector('[data-reviews-form-wrap]').hidden = true;
      dialog.querySelector('[data-reviews-thanks]').hidden = false;
    },

    bindNative: function (root, dialog, form) {
      var self = this;
      var error = dialog.querySelector('[data-reviews-error]');
      var button = form.querySelector('[data-reviews-submit]');
      var original = button ? button.textContent : '';
      ContactForm.bind(form, {
        busy: function (on) {
          if (on && error) error.hidden = true;
          if (button) { button.disabled = on; button.textContent = on ? (dialog.dataset.msgSending || '…') : original; }
        },
        success: function () { self.showThanks(dialog, form); },
        error: function (messages) {
          if (!error) return;
          error.textContent = messages && messages.length ? messages.join(' ') : (dialog.dataset.msgError || '');
          error.hidden = false;
        },
        hide: function () { if (dialog.open) dialog.close(); },
        restore: function () { if (!dialog.open) { dialog.showModal(); document.body.style.overflow = 'hidden'; } },
      });
      // Tornada d'un enviament natiu d'aquesta ressenya (?contact_posted=true#id-del-formulari): mostrem l'agraïment.
      if (ContactForm.returnedFromPost() && form.id && window.location.hash === '#' + form.id) {
        if (typeof dialog.showModal === 'function' && !dialog.open) { dialog.showModal(); document.body.style.overflow = 'hidden'; }
        self.showThanks(dialog, form);
        ContactForm.cleanUrl();
      }
    },

    submit: function (dialog, form) {
      var self = this;
      var error = dialog.querySelector('[data-reviews-error]');
      var button = form.querySelector('[data-reviews-submit]');
      var original = button ? button.textContent : '';
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var honeypot = form.querySelector('[name="hp_website"]');
      if (honeypot && honeypot.value) { self.showThanks(dialog, form); return; }

      var endpoint = form.dataset.mode === 'endpoint';
      if (error) error.hidden = true;
      if (button) { button.disabled = true; button.textContent = dialog.dataset.msgSending || '…'; }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: endpoint ? { Accept: 'application/json' } : {},
        redirect: 'follow',
      })
        .then(function (response) {
          if (endpoint) {
            if (!response.ok) throw new Error('endpoint');
            return 'ok';
          }
          if (response.url.indexOf('/challenge') > -1) {
            form.submit();
            return 'native';
          }
          if (response.url.indexOf('contact_posted=true') === -1) throw new Error('not-posted');
          return 'ok';
        })
        .then(function (result) {
          if (result === 'ok') self.showThanks(dialog, form);
        })
        .catch(function () {
          if (error) { error.textContent = dialog.dataset.msgError || ''; error.hidden = false; }
        })
        .finally(function () {
          if (button) { button.disabled = false; button.textContent = original; }
        });
    },

    /* ---- customer photo / video ---- */
    openMedia: function (root, trigger) {
      var tpl = trigger.querySelector('template[data-review-media-template]');
      var dialog = root.querySelector('[data-review-lightbox]');
      var stage = dialog && dialog.querySelector('[data-review-lightbox-stage]');
      if (!tpl || !stage || typeof dialog.showModal !== 'function') return;
      stage.innerHTML = '';
      stage.appendChild(tpl.content.cloneNode(true));
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    },

    init: function () {
      var self = this;
      var roots = document.querySelectorAll('[data-reviews]');
      if (!roots.length) return;

      roots.forEach(function (root) {
        self.update(root);
        root.querySelectorAll('dialog').forEach(function (dialog) {
          dialog.addEventListener('click', function (event) { if (event.target === dialog) self.closeDialog(dialog); });
          dialog.addEventListener('close', function () { self.closeDialog(dialog); });
        });
        var form = root.querySelector('[data-reviews-form]');
        var modal = root.querySelector('[data-reviews-modal]');
        if (form && modal) {
          // Formulari de contacte de Shopify (ressenya per correu): el mateix enviament que el de contacte, perquè l'hCaptcha
          // de Shopify no el torni a enviar ell sol (abans arribava dues vegades i mostrava un error fals).
          // ContactForm es defineix més avall: l'enllacem quan tot el fitxer ja s'ha executat.
          if (form.dataset.mode === 'native') {
            document.addEventListener('DOMContentLoaded', function () { self.bindNative(root, modal, form); });
          } else {
            form.addEventListener('submit', function (event) { event.preventDefault(); self.submit(modal, form); });
          }
          var input = form.querySelector('[data-reviews-file]');
          if (input) input.addEventListener('change', function () { self.onFiles(modal, input); });
        }
      });

      document.addEventListener('click', function (event) {
        var root = event.target.closest('[data-reviews]');
        if (!root) return;
        if (event.target.closest('[data-reviews-prev]')) return self.step(root, -1);
        if (event.target.closest('[data-reviews-next]')) return self.step(root, 1);
        var toggle = event.target.closest('[data-reviews-toggle]');
        if (toggle) return self.toggleAll(root, toggle);
        var more = event.target.closest('[data-reviews-load-more]');
        if (more) return self.loadMore(root, more);
        if (event.target.closest('[data-reviews-open-form]')) return self.openForm(root);
        var dialog = event.target.closest('dialog');
        if (dialog && event.target.closest('[data-reviews-close], [data-reviews-cancel], [data-review-lightbox-close]')) return self.closeDialog(dialog);
        var media = event.target.closest('[data-review-media]');
        if (media) self.openMedia(root, media);
      });

      var ticking = false;
      document.addEventListener('scroll', function (event) {
        var track = event.target;
        if (!track || !track.matches || !track.matches('[data-reviews-track]') || ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var root = track.closest('[data-reviews]');
          if (root) self.update(root);
        });
      }, true);

      window.addEventListener('resize', function () {
        roots.forEach(function (root) { self.update(root); });
      });

      document.addEventListener('shopify:block:select', function (event) {
        var card = event.target.closest && event.target.closest('.review-card');
        if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      });
    },
  };
  Reviews.init();

  /* ---------------- «¿Ya tienes el libro?» ----------------
     [data-select-pack]: «Comprar el pack» fa el mateix que els altres botons de compra del pack (preguntes freqüents,
       4 misiones): selecciona el pack a l'heroi i en prem el botó de compra, que l'afegeix a la motxilla i l'obre
       (o, des de fora d'Espanya, obre la llista d'espera). Abans pujava a l'heroi: als mòbils només s'hi veia el títol
       i les fotos, i semblava que el botó no feia res. Sense heroi a la pàgina, segueix l'enllaç.
     [data-pack-price-label]: copia el preu del pack de l'heroi al text del botó.
     [data-dx-pending]: botó sense producte ni enllaç encara; no fa res. */
  (function () {
    var heroPrice = document.querySelector('[data-pack-switcher] .hero-pack__panel[data-pack-panel="essential"] .price--lg');
    var price = heroPrice && cleanText(heroPrice.textContent);
    if (price) {
      document.querySelectorAll('[data-pack-price-label]').forEach(function (el) {
        if (el.dataset.template) el.textContent = el.dataset.template.replace('{price}', price);
      });
    }
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-dx-pending]')) { event.preventDefault(); return; }
      var link = event.target.closest && event.target.closest('[data-select-pack]');
      if (!link) return;
      var key = link.dataset.selectPack;
      var switcher = document.querySelector('.hero-pack [data-pack-switcher]');
      var buy = switcher && PackAnatomy.heroCta(key);
      if (!buy) return; // sense heroi (o sense botó de compra): segueix l'enllaç
      event.preventDefault();
      if (switcher.querySelector('[data-pack-tab="' + key + '"]')) PackSwitcher.select(switcher, key);
      buy.click();
    });
  })();

  /* ---------------- Botons «Conseguir el pack» fora de la landing ----------------
     La lògica principal viu a PackAnatomy (només a la landing). A la resta de pàgines (El Club, La Autora…)
     el botó prem el de l'heroi si n'hi ha, i si no porta a l'enllaç de reserva (/#pack). */
  if (!document.querySelector('[data-pack-anatomy]')) {
    document.addEventListener('click', function (event) {
      var cta = event.target.closest && event.target.closest('[data-pack-cta]');
      if (!cta) return;
      var heroButton = document.querySelector('[data-pack-switcher] .hero-pack__cta:not([hidden]) .btn');
      if (heroButton) heroButton.click();
      else if (cta.dataset.fallbackHref) window.location.href = cta.dataset.fallbackHref;
    });
  }

  /* ---------------- Hero: nota de las reseñas (la mateixa dada que la secció de ressenyes) ---------------- */
  var HeroProof = {
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },

    fill: function (proof, reviews) {
      var rating = reviews.dataset.rating;
      if (!rating) {
        // Sense ressenyes reals suficients: no ensenyem cinc estrelles plenes que ningú ha donat; només el text.
        var emptyStars = proof.querySelector('[data-hero-stars]');
        if (emptyStars) emptyStars.hidden = true;
        return;
      }
      var count = parseInt(reviews.dataset.reviewCount, 10) || 0;
      var verified = reviews.dataset.statsKind === 'verified';
      var one = count === 1;
      var template = verified ? (one ? proof.dataset.tplVerifiedOne : proof.dataset.tplVerified) : (one ? proof.dataset.tplOne : proof.dataset.tpl);
      if ((reviews.dataset.statsKind === 'trustpilot' || reviews.dataset.demoLabel) && proof.dataset.tplTp) template = proof.dataset.tplTp;
      var score = proof.querySelector('[data-hero-proof-score]');
      if (score && template) {
        score.textContent = template.replace('%RATING%', rating).replace('%COUNT%', count);
        score.hidden = false;
        proof.classList.add('has-score');
        if (reviews.dataset.demoLabel && !proof.querySelector('.review-demo')) {
          var demo = document.createElement('span');
          demo.className = 'review-demo';
          demo.textContent = reviews.dataset.demoLabel;
          score.insertAdjacentElement('afterend', demo);
        }
      }
      var stars = proof.querySelector('[data-hero-stars]');
      if (stars) {
        var targetPct = reviews.dataset.ratingPct + '%';
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', (stars.dataset.label || '').replace('%RATING%', rating));
        stars.removeAttribute('aria-hidden');
        if (this.reduced()) {
          stars.style.setProperty('--pct', targetPct);
        } else {
          stars.style.setProperty('--pct', '0%');
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              stars.style.setProperty('--pct', targetPct);
            });
          });
        }
      }
    },

    // La capçalera fa de barra fixa a dalt (el seu contenidor és sticky): la secció de destí ha de quedar just a sota.
    headerOverlap: function () {
      var header = document.querySelector('.site-header');
      if (!header) return 0;
      var holder = header.closest('.shopify-section') || header;
      var position = window.getComputedStyle(holder).position;
      if (position === 'fixed' || position === 'sticky' || window.getComputedStyle(header).position === 'fixed') return header.offsetHeight;
      return 0;
    },

    scrollToReviews: function (reviews) {
      var padding = parseFloat(window.getComputedStyle(reviews).paddingTop) || 0;
      var top = reviews.getBoundingClientRect().top + window.pageYOffset + padding - this.headerOverlap() - 40;
      window.scrollTo({ top: Math.max(0, top), behavior: this.reduced() ? 'auto' : 'smooth' });
    },

    init: function () {
      var self = this;
      var proof = document.querySelector('[data-hero-proof]');
      if (!proof) return;
      var reviews = document.querySelector('[data-reviews]');
      if (reviews) self.fill(proof, reviews);
      proof.addEventListener('click', function (event) {
        var target = document.querySelector('[data-reviews]');
        if (!target) return; // sense secció: l'enllaç #testimonials fa la seva feina
        event.preventDefault();
        self.scrollToReviews(target);
      });
    },
  };
  HeroProof.init();

  // «Llibre amb volum» que gira: només mentre es veu a la pantalla (fora de pantalla o amb l'opció amagada, s'atura).
  (function () {
    var books = document.querySelectorAll('.hero-book--spin');
    if (!books.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { entry.target.classList.toggle('is-paused', !entry.isIntersecting); });
    });
    books.forEach(function (book) { io.observe(book); });
  })();

  // Enllaços amb àncora (#pack…): el CSS fa servir --header-h perquè la secció no quedi sota la capçalera fixa.
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var set = function () { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
    set();
    window.addEventListener('resize', set);
  })();

  // Enllaç «escriu la teva ressenya» (correu post-compra): baixa a la secció i obre el formulari.
  (function () {
    var root = document.querySelector('[data-reviews]');
    if (root && Reviews.linkParams().open) {
      HeroProof.scrollToReviews(root);
      Reviews.openForm(root);
    }
  })();

  /* ---------------- Formularis de contacte de Shopify (modal de contacte del peu + llista d'espera) ----------------
     Shopify protegeix els formularis de contacte amb hCaptcha: quan s'hi entra, el seu script (captcha-bootstrap) hi enganxa
     un listener de «submit» que demana un testimoni i després envia el formulari de manera NATIVA amb form.submit(), és a dir,
     amb la funció form.submit que hi troba en el moment d'enganxar-se. Abans això feia un doble enviament: el nostre fetch
     (sense testimoni: resposta sense contact_posted=true → «Ha habido un problema…») i l'enviament natiu (el que arribava,
     amb recàrrega de pàgina i el camp «Website» al correu).
     Ara substituïm form.submit abans que l'hCaptcha s'hi enganxi: quan té el testimoni, crida el nostre enviament per fetch,
     que el porta. Si el formulari no està protegit (o el captcha no ha carregat), enviem directament.
     L'èxit es llegeix de l'URL final (?contact_posted=true) o de l'estat que el Liquid escriu a l'HTML retornat
     ([data-contact-status] dins el mateix formulari), i els errors de Shopify (correu no vàlid…) es mostren tal qual.
     opts: { busy(on), success(), error(missatges), hide(), restore(), beforeNative() } */
  var ContactForm = {
    honeypot: 'hp_website',

    bind: function (form, opts) {
      var self = this;
      form._contactOpts = opts;
      // L'hCaptcha la crida quan ja ha posat el testimoni (h-captcha-response) al formulari.
      form.submit = function () { self.send(form); };
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (form._contactBusy) return;
        if (!form.checkValidity()) { form.reportValidity(); return; }
        self.setBusy(form, true);
        // Protegit: el listener de l'hCaptcha (va després d'aquest) demana el testimoni i crida form.submit() → send().
        if (form.hasAttribute('data-hcaptcha-bound')) self.waitCaptcha(form);
        else self.send(form);
      });
    },

    setBusy: function (form, on) {
      form._contactBusy = on;
      if (!on) form._contactSending = false;
      form._contactOpts.busy(on);
    },

    // Mentre l'hCaptcha treballa. Si ha de mostrar un repte visual, el modal (capa superior) el taparia: el tanquem mentre dura
    // i el tornem a obrir després. Si no arriba res (captcha bloquejat, error…), enviem sense testimoni: si Shopify vol una
    // verificació respondrà /challenge, i hi passarem amb l'enviament natiu.
    waitCaptcha: function (form) {
      var self = this;
      var started = Date.now();
      var goneAt = 0;
      self.stopWaiting(form);
      form._captchaTimer = window.setInterval(function () {
        if (self.challengeVisible()) {
          goneAt = 0;
          if (!form._hiddenForChallenge) { form._hiddenForChallenge = true; form._contactOpts.hide(); }
          return;
        }
        if (form._hiddenForChallenge) {
          // Repte tancat sense resoldre'l (si s'hagués resolt, send() ja hauria aturat aquesta espera).
          if (!goneAt) goneAt = Date.now();
          else if (Date.now() - goneAt > 1500) { self.stopWaiting(form); self.restore(form); self.setBusy(form, false); }
          return;
        }
        if (Date.now() - started > 15000) { self.stopWaiting(form); self.send(form); }
      }, 250);
    },

    stopWaiting: function (form) {
      if (form._captchaTimer) window.clearInterval(form._captchaTimer);
      form._captchaTimer = null;
    },

    restore: function (form) {
      if (!form._hiddenForChallenge) return;
      form._hiddenForChallenge = false;
      form._contactOpts.restore();
    },

    challengeVisible: function () {
      var frames = document.querySelectorAll('iframe[src*="hcaptcha"]');
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].src.indexOf('frame=challenge') === -1) continue;
        var box = frames[i].getBoundingClientRect();
        if (box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < window.innerHeight && window.getComputedStyle(frames[i]).visibility === 'visible') return true;
      }
      return false;
    },

    send: function (form) {
      var self = this;
      var opts = form._contactOpts;
      if (!form._contactBusy || form._contactSending) return; // crida tardana de l'hCaptcha o doble clic
      self.stopWaiting(form);
      self.restore(form);
      var trap = form.querySelector('[name="' + self.honeypot + '"]');
      if (trap && trap.value) { self.setBusy(form, false); opts.success(); return; } // robot: fem veure que s'ha enviat
      form._contactSending = true;

      // Shopify posa cada contact[...] al correu, en aquest ordre; el parany antispam no hi ha d'anar.
      var data = new FormData(form);
      data.delete(self.honeypot);
      form.querySelectorAll('[data-contact-optional]').forEach(function (input) {
        if (!input.value.trim()) data.set(input.name, '—');
      });

      fetch(form.action, { method: 'POST', body: data, redirect: 'follow' })
        .then(function (response) { return self.read(form, response); })
        .then(function (result) {
          if (result.status === 'challenge' || result.status === 'unknown') { self.nativeSubmit(form); return; }
          self.setBusy(form, false);
          if (result.status === 'posted') opts.success();
          else opts.error(result.messages || []);
        })
        .catch(function () {
          self.setBusy(form, false);
          opts.error([]);
        });
    },

    // Què ha respost Shopify: posted | errors (amb els missatges) | challenge | unknown
    read: function (form, response) {
      if (response.url.indexOf('/challenge') > -1) return { status: 'challenge' };
      if (response.url.indexOf('contact_posted=true') > -1) return { status: 'posted' };
      if (!response.ok) return { status: 'failed' };
      return response.text().then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var scope = (form.id && doc.getElementById(form.id)) || doc;
        var marker = scope.querySelector('[data-contact-status]');
        var status = marker ? marker.getAttribute('data-contact-status') : '';
        if (status === 'posted') return { status: 'posted' };
        if (status !== 'errors') return { status: 'unknown' };
        var messages = [];
        var tpl = scope.querySelector('template[data-contact-errors]');
        if (tpl && tpl.content) {
          tpl.content.querySelectorAll('li').forEach(function (li) {
            var text = li.textContent.replace(/\s+/g, ' ').trim();
            if (text) messages.push(text);
          });
        }
        return { status: 'errors', messages: messages };
      });
    },

    // Resposta que no sabem llegir o verificació de Shopify: enviament clàssic (pàgina /challenge si cal i tornada amb ?contact_posted=true).
    nativeSubmit: function (form) {
      var trap = form.querySelector('[name="' + this.honeypot + '"]');
      if (trap) trap.disabled = true;
      form.querySelectorAll('[data-contact-optional]').forEach(function (input) {
        if (!input.value.trim()) input.value = '—';
      });
      if (form._contactOpts.beforeNative) form._contactOpts.beforeNative();
      HTMLFormElement.prototype.submit.call(form);
    },

    // Tornada d'un enviament natiu: l'URL porta ?contact_posted=true (i potser #id-del-formulari). El traiem perquè una
    // recàrrega no torni a obrir l'agraïment.
    returnedFromPost: function () {
      return new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    },

    cleanUrl: function () {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('contact_posted');
        url.hash = '';
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    },
  };

  /* ---------------- Peu de pàgina: modal de contacte ---------------- */
  var FooterContact = {
    open: function (dialog) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var wrap = dialog.querySelector('[data-footer-contact-form-wrap]');
      var thanks = dialog.querySelector('[data-footer-contact-thanks]');
      var error = dialog.querySelector('[data-footer-contact-error]');
      var heading = dialog.querySelector('.reviews-modal__title');
      if (wrap) wrap.hidden = false;
      if (thanks) thanks.hidden = true;
      if (error) error.hidden = true;
      dialog.classList.remove('is-sent');
      if (heading && heading.id) dialog.setAttribute('aria-labelledby', heading.id);
      if (!dialog.open) dialog.showModal();
      focusDialogTitle(dialog);
      document.body.style.overflow = 'hidden';
    },

    close: function (dialog) {
      if (dialog.open) dialog.close();
      document.body.style.overflow = '';
    },

    // Enviat: només el missatge d'agraïment (sense el títol «¿En qué podemos ayudarte?»).
    showThanks: function (dialog, form) {
      if (form) form.reset();
      dialog.querySelector('[data-footer-contact-form-wrap]').hidden = true;
      dialog.querySelector('[data-footer-contact-thanks]').hidden = false;
      dialog.classList.add('is-sent');
      var title = dialog.querySelector('[data-footer-contact-thanks-title]');
      if (title) {
        if (title.id) dialog.setAttribute('aria-labelledby', title.id);
        if (dialog.open) title.focus({ preventScroll: true });
      }
    },

    showError: function (dialog, messages) {
      var error = dialog.querySelector('[data-footer-contact-error]');
      if (!error) return;
      error.textContent = messages && messages.length ? messages.join(' ') : (error.dataset.defaultText || '');
      error.hidden = false;
    },

    init: function () {
      var self = this;
      var dialog = document.querySelector('[data-footer-contact-modal]');
      if (!dialog) return;

      dialog.addEventListener('click', function (event) { if (event.target === dialog) self.close(dialog); });
      dialog.addEventListener('close', function () { self.close(dialog); });

      var form = dialog.querySelector('[data-footer-contact-form]');
      var error = dialog.querySelector('[data-footer-contact-error]');
      if (error) error.dataset.defaultText = error.textContent.trim();
      if (form) {
        var button = form.querySelector('[data-footer-contact-submit]');
        var label = button ? button.textContent : '';
        ContactForm.bind(form, {
          busy: function (on) {
            if (on && error) error.hidden = true;
            if (button) { button.disabled = on; button.textContent = on ? (dialog.dataset.msgSending || '…') : label; }
          },
          success: function () { self.showThanks(dialog, form); },
          error: function (messages) { self.showError(dialog, messages); },
          hide: function () { if (dialog.open) dialog.close(); },
          restore: function () { if (!dialog.open) { dialog.showModal(); document.body.style.overflow = 'hidden'; } },
        });
      }

      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-footer-contact-open]')) { self.open(dialog); return; }
        if (event.target.closest('[data-footer-contact-close], [data-footer-contact-cancel]')) self.close(dialog);
      });

      // Tornada d'un enviament natiu (sense JS o després de la verificació de Shopify): obrim el modal ja amb l'agraïment.
      // Si l'àncora és d'un altre formulari (llista d'espera, ressenyes) o hi ha una alta a la llista pendent, no és nostre.
      var hash = window.location.hash;
      var ours = !hash || (form && hash === '#' + form.id);
      if (ContactForm.returnedFromPost() && ours && !intlWaitlistPending()) {
        self.open(dialog);
        self.showThanks(dialog, null);
        ContactForm.cleanUrl();
      }
    },
  };
  document.addEventListener('DOMContentLoaded', function () { FooterContact.init(); });

  /* ---------------- Llista d'espera internacional ----------------
     Buy buttons of products that can't be bought in the visitor's country carry [data-intl-waitlist-open]
     (snippets/buy-buttons.liquid). Sign-ups are sent through Shopify's contact form (ContactForm, above).
     «Ver los productos digitales» ([data-intl-waitlist-digital]): tanca la finestra i baixa a la secció digital si és
     a la pàgina; si no, l'enllaç porta a la pàgina d'inici de l'idioma actual amb l'ancoratge (/#… o /ca#…).
     En mode llista d'espera, snippets/waiting-list-gate.liquid deixa passar aquests botons (no són una compra). */
  function intlWaitlistPending() {
    try { return sessionStorage.getItem('intlWaitlistPending') === '1'; } catch (e) { return false; }
  }

  var IntlWaitlist = {
    open: function (dialog, opener) {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var product = dialog.querySelector('[data-intl-waitlist-product]');
      if (product) product.value = (opener && opener.dataset.product) || '';
      dialog.querySelector('[data-intl-waitlist-form-wrap]').hidden = false;
      dialog.querySelector('[data-intl-waitlist-thanks]').hidden = true;
      dialog.querySelector('[data-intl-waitlist-error]').hidden = true;
      dialog.classList.remove('is-sent');
      dialog.setAttribute('aria-labelledby', 'IntlWaitlistTitle');
      dialog._scrollY = window.pageYOffset;
      if (!dialog.open) dialog.showModal();
      focusDialogTitle(dialog);
      document.body.style.overflow = 'hidden';
    },

    close: function (dialog) {
      if (dialog.open) dialog.close();
      if (!document.querySelector('dialog[open]')) document.body.style.overflow = '';
    },

    // Secció dels productes digitals: primer per l'ancoratge; si no hi és (en català l'ancoratge de la secció pot estar
    // traduït a una altra cosa), la secció «¿Ya tienes el libro?» (sections/digital-experience.liquid → section.dx).
    digitalTarget: function (anchor) {
      return (anchor && document.getElementById(anchor)) || document.querySelector('section.dx');
    },

    // Just sota la capçalera fixa, com els altres enllaços a seccions (Anchors, més avall).
    scrollToDigital: function (target, smooth) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var header = document.querySelector('.site-header');
      var top = target.getBoundingClientRect().top + window.pageYOffset - (header ? header.offsetHeight : 0);
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: smooth && !reduced ? 'smooth' : 'auto' });
    },

    // Arribada des d'una altra pàgina amb #ancoratge. Si l'ancoratge existeix, ja hi porten el navegador i Anchors.
    // Si no (traduït en aquest idioma), baixem a la secció digital i, en acabar de carregar, s'hi torna a alinear
    // mentre el visitant no s'hagi mogut. En recarregar o tornar enrere, el navegador ja el deixa on era.
    arriveAtDigital: function (anchor) {
      var self = this;
      var hash = '';
      try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { hash = window.location.hash.slice(1); }
      if (!anchor || hash !== anchor || document.getElementById(anchor)) return;
      try {
        var nav = window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
        if (nav && (nav.type === 'reload' || nav.type === 'back_forward')) return;
      } catch (e) {}
      var target = self.digitalTarget(anchor);
      if (!target) return;
      var moved = false;
      var stop = function () { moved = true; };
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) { window.addEventListener(type, stop, { once: true, passive: true }); });
      self.scrollToDigital(target, false);
      var settle = function () { if (!moved) self.scrollToDigital(target, false); };
      if (document.readyState === 'complete') window.setTimeout(settle, 0);
      else window.addEventListener('load', settle, { once: true });
    },

    // Enviat: només l'agraïment, com al modal de contacte.
    showThanks: function (dialog, form) {
      if (form) form.reset();
      dialog.querySelector('[data-intl-waitlist-form-wrap]').hidden = true;
      dialog.querySelector('[data-intl-waitlist-thanks]').hidden = false;
      dialog.classList.add('is-sent');
      var title = dialog.querySelector('[data-intl-waitlist-thanks-title]');
      if (title) {
        if (title.id) dialog.setAttribute('aria-labelledby', title.id);
        if (dialog.open) title.focus({ preventScroll: true });
      }
    },

    init: function () {
      var self = this;
      var dialog = document.querySelector('[data-intl-waitlist]');
      if (!dialog) return;
      var form = dialog.querySelector('[data-intl-waitlist-form]');
      var error = dialog.querySelector('[data-intl-waitlist-error]');

      dialog.addEventListener('click', function (event) { if (event.target === dialog) self.close(dialog); });
      dialog.addEventListener('close', function () { if (!document.querySelector('dialog[open]')) document.body.style.overflow = ''; });

      if (form) {
        var button = form.querySelector('[data-intl-waitlist-submit]');
        var label = button ? button.textContent : '';
        if (error) error.dataset.defaultText = error.textContent.trim();
        ContactForm.bind(form, {
          busy: function (on) {
            if (on && error) error.hidden = true;
            if (button) { button.disabled = on; button.textContent = on ? '…' : label; }
          },
          success: function () { self.showThanks(dialog, form); },
          error: function (messages) {
            if (!error) return;
            error.textContent = messages && messages.length ? messages.join(' ') : (error.dataset.defaultText || '');
            error.hidden = false;
          },
          hide: function () { if (dialog.open) dialog.close(); },
          restore: function () { if (!dialog.open) { dialog.showModal(); document.body.style.overflow = 'hidden'; } },
          beforeNative: function () { try { sessionStorage.setItem('intlWaitlistPending', '1'); } catch (e) {} },
        });
      }

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-intl-waitlist-open]');
        if (opener) { event.preventDefault(); self.open(dialog, opener); return; }
        if (event.target.closest('[data-intl-waitlist-close]')) self.close(dialog);
        var digital = event.target.closest('[data-intl-waitlist-digital]');
        if (digital) {
          self.close(dialog);
          // A la landing amb l'ancoratge, Anchors (més avall) ja ha cancel·lat l'enllaç i hi baixa.
          if (event.defaultPrevented) return;
          var target = self.digitalTarget(digital.dataset.anchor);
          if (!target) return; // una altra pàgina: segueix l'enllaç (pàgina d'inici + ancoratge)
          event.preventDefault();
          // Després de tancar: el focus torna al botó que l'havia obert i no ha de desfer el desplaçament.
          window.requestAnimationFrame(function () { self.scrollToDigital(target, true); });
        }
      });

      var digitalLink = dialog.querySelector('[data-intl-waitlist-digital]');
      if (digitalLink) self.arriveAtDigital(digitalLink.dataset.anchor);

      // Native fallback (bot challenge): Shopify reloads with ?contact_posted=true (the hash may be lost on the way).
      var pending = intlWaitlistPending();
      try { sessionStorage.removeItem('intlWaitlistPending'); } catch (e) {}
      if (ContactForm.returnedFromPost() && (window.location.hash === '#IntlWaitlistForm' || pending)) {
        self.open(dialog, null);
        self.showThanks(dialog, null);
        ContactForm.cleanUrl();
      }
    },
  };
  document.addEventListener('DOMContentLoaded', function () { IntlWaitlist.init(); });

  /* ---------------- Cart drawer ---------------- */
  // Motxilla: calaix (sections/cart-drawer) i pàgina /cart (sections/main-cart).
  // Rapidesa (Feedback 3, «la motxilla va bastant lenta»):
  // - Cada acció és UNA sola petició a l'Ajax Cart API amb «sections»: la resposta ja porta el calaix (i, a /cart, la
  //   secció de la pàgina) pintat. Abans eren dues o tres peticions seguides (add/change → ?sections=cart-drawer,header
  //   → a /cart, la pàgina). El número de la icona surt del calaix (data-item-count): la capçalera no es torna a pintar.
  // - Resposta immediata: la quantitat canvia a l'instant, la línia eliminada s'esvaeix i el calaix s'obre en clicar
  //   «Añadir»; preus i total queden atenuats (amb una barra a dalt) fins que arriba la resposta.
  // - Les peticions van en fila (una alhora, sense curses) i els clics seguits de +/− s'ajunten: només es pinta l'estat
  //   final. «−» amb 1 unitat ja no fa cap petició.
  // - Les línies es reconeixen per la clau (item.key), no per la posició.
  // - El calaix, el fons fosc i la secció de /cart són sempre els mateixos elements (només en canvia el contingut): es
  //   conserven l'estat obert, el focus, els desplegables oberts, el text escrit (nota, codi) i el scroll.
  // - Les peticions van a /cart/… sense el prefix de l'idioma (al domini myshopify, POST /ca/cart/add.js torna 404) i el
  //   contingut es pinta en l'idioma de la pàgina amb sections_url.
  // - Enter dins la quantitat d'una línia aplica la quantitat (no envia el formulari: aniria al pagament).
  // fb-cart.js (canvi al pack, canvi d'edició, codi de descompte) fa servir aquestes mateixes funcions: window.ClubCart.
  var CartDrawer = {
    root: null,
    overlay: null,
    queue: null,
    pending: {},
    flushing: null,
    busy: 0,
    locked: 0,

    init: function () {
      this.root = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-drawer-overlay]');
      this.queue = Promise.resolve();
      window.ClubCart = this;
      if (!this.root) return;

      document.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') CartDrawer.close();
        // Enter dins la quantitat d'una línia (calaix i /cart): aplica la quantitat. Sense això, el navegador enviava el
        // formulari de la motxilla amb el seu primer botó, «Finalizar compra», i anava al pagament (el camp del codi de
        // descompte ja ho evita a fb-cart.js).
        if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-cart-line-input]')) {
          event.preventDefault();
          CartDrawer.applyInput(event.target);
        }
      });
      document.addEventListener('submit', this.handleSubmit.bind(this));
      document.addEventListener('change', this.handleChange.bind(this));
      // Tornant enrere des del pagament, el navegador pot mostrar la pàgina desada amb una motxilla antiga.
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) CartDrawer.refresh();
      });
    },

    handleClick: function (event) {
      // Links inside the drawer (e.g. "Empezar la aventura" -> /#pack) must close it so the target section is visible.
      if (event.target.closest('[data-cart-drawer] a[href]')) this.close();
      if (event.target.closest('[data-cart-toggle]')) {
        event.preventDefault();
        this.open();
      }
      if (event.target.closest('[data-cart-drawer-close]') || event.target.closest('[data-cart-drawer-overlay]')) {
        event.preventDefault();
        this.close();
      }
      var qtyBtn = event.target.closest('[data-quantity-plus], [data-quantity-minus]');
      if (qtyBtn) {
        event.preventDefault();
        // Mentre un canvi d'edició o al pack espera o és en camí, les línies de la motxilla no canvien (vegeu setLocked).
        if (this.locked && qtyBtn.closest('[data-cart-line]')) return;
        var wrapper = qtyBtn.closest('[data-quantity-wrapper], .cart-item__qty');
        var input = wrapper && wrapper.querySelector('input[type="number"], [data-quantity-input]');
        if (!input) return;
        var step = parseInt(input.step, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        var value = parseInt(input.value, 10) || min;
        value = qtyBtn.hasAttribute('data-quantity-plus') ? value + step : Math.max(min, value - step);
        if (String(value) === input.value) return;
        input.value = value;
        if (input.hasAttribute('data-cart-line-input')) this.setQuantity(input, value);
      }
      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        this.setQuantity(removeBtn, 0);
      }
    },

    handleChange: function (event) {
      if (event.target.matches('[data-variant-select]')) {
        var form = event.target.closest('form');
        var hiddenInput = form && form.querySelector('[data-variant-id]');
        if (hiddenInput) hiddenInput.value = event.target.value;
      }
      if (event.target.matches('[data-cart-line-input]')) this.applyInput(event.target);
      // Nota de la comanda: es desa en sortir del camp, sense tornar a pintar res.
      if (event.target.matches('[data-cart-note]')) {
        var note = event.target.value;
        document.querySelectorAll('[data-cart-note]').forEach(function (el) {
          if (el !== event.target) el.value = note;
        });
        this.run(function () {
          return CartDrawer.request('cart/update.js', { note: note }, { sections: false });
        }).catch(function () {});
      }
    },

    handleSubmit: function (event) {
      var form = event.target.closest('[data-cart-form]');
      if (!form) return;
      event.preventDefault();
      var self = this;
      var button = form.querySelector('[data-add-to-cart-button]');
      var label = button && button.querySelector('[data-button-text]');
      var originalText = label ? label.textContent : null;

      if (button) button.setAttribute('disabled', 'disabled');
      if (label) label.textContent = label.dataset.loadingText || label.textContent;

      // El calaix s'obre de seguida, amb la barra de càrrega, i s'omple quan arriba la resposta.
      this.open();
      this.setLoading(true);
      this.mutate('cart/add.js', Object.fromEntries(new FormData(form)))
        .catch(function (error) {
          self.showError(self.errorText(error, self.root.dataset.msgAddError));
        })
        .then(function () {
          self.setLoading(false);
          if (button) button.removeAttribute('disabled');
          if (label && originalText) label.textContent = originalText;
        });
    },

    // Quantitat escrita al camp d'una línia, en sortir del camp o amb Enter. Si és la que ja té la línia (o la darrera
    // demanada amb Enter, «+» o «−», data-sent), no fa cap petició: així Enter i, després, sortir del camp no l'envien
    // dues vegades. Buit o 0 = eliminar la línia, com abans.
    applyInput: function (input) {
      var value = Math.max(0, parseInt(input.value, 10) || 0);
      var current = input.getAttribute('data-sent') || input.defaultValue;
      if (this.locked || String(value) === current) {
        input.value = current;
        return;
      }
      this.setQuantity(input, value);
    },

    // Quantitat d'una línia (0 = eliminar-la). La pantalla canvia a l'instant; la petició surt (o s'ajunta) a flush().
    setQuantity: function (control, quantity) {
      var line = control.closest('[data-cart-line]');
      var key = (line && line.dataset.key) || control.dataset.key;
      if (!key || this.locked) return;
      // La mateixa línia pot ser al calaix i a la pàgina /cart: canvien totes dues.
      document.querySelectorAll('[data-cart-line]').forEach(function (el) {
        if (el.dataset.key !== key) return;
        el.classList.add(quantity === 0 ? 'is-removing' : 'is-pending');
        var input = el.querySelector('[data-cart-line-input]');
        if (!input) return;
        if (quantity > 0) input.value = quantity;
        input.setAttribute('data-sent', quantity);
      });
      this.pending[key] = quantity;
      this.flush();
    },

    // Envia els canvis de quantitat pendents. Si mentre la petició és en camí n'arriben més, se n'envia una altra abans
    // de pintar res: només es pinta l'estat final. Un sol canvi va a /cart/change.js; uns quants, a /cart/update.js.
    flush: function () {
      var self = this;
      if (this.flushing) return this.flushing;
      var send = function () {
        var batch = self.pending;
        self.pending = {};
        var keys = Object.keys(batch);
        if (!keys.length) return null;
        var call = keys.length === 1
          ? self.request('cart/change.js', { id: keys[0], quantity: batch[keys[0]] })
          : self.request('cart/update.js', { updates: batch });
        return call.then(function (data) {
          if (Object.keys(self.pending).length) return send();
          self.render(data.sections);
          return data;
        });
      };
      this.setBusy(true);
      this.flushing = this.run(send)
        .catch(function (error) {
          self.pending = {};
          return self.resync(self.errorText(error, self.root && self.root.dataset.msgUpdateError));
        })
        .then(function () {
          self.flushing = null;
          self.setBusy(false);
          if (Object.keys(self.pending).length) self.flush();
        });
      return this.flushing;
    },

    // Una acció de la motxilla: una petició amb «sections» i, quan arriba, es pinta. Torna la resposta de Shopify (el
    // carret o els productes afegits). Si falla, rebutja amb l'error de Shopify: qui la crida decideix el missatge.
    // - body pot ser una funció: es crida quan arriba el torn de l'acció a la fila, amb la motxilla ja repintada per les
    //   accions d'abans. El canvi d'edició i el canvi al pack en calculen la petició així: si s'ha clicat «+» o «−» just
    //   abans, esperen la resposta i fan servir les quantitats noves. Si torna null, no es fa cap petició (torna null).
    // - options.lock: des del clic fins a la resposta, els controls de quantitat de les línies no fan res (setLocked).
    mutate: function (path, body, options) {
      var self = this;
      var lock = !!(options && options.lock);
      this.setBusy(true);
      if (lock) this.setLocked(true);
      var done = function () {
        self.setBusy(false);
        if (lock) self.setLocked(false);
      };
      return this.run(function () {
        var payload = typeof body === 'function' ? body() : body;
        if (!payload) return null;
        return self.request(path, payload, options).then(function (data) {
          self.render(data.sections);
          return data;
        });
      }).then(function (data) {
        done();
        return data;
      }, function (error) {
        done();
        throw error;
      });
    },

    // Fila d'accions: cada una comença quan l'anterior ha acabat (bé o malament).
    run: function (task) {
      var result = this.queue.then(task);
      this.queue = result.catch(function () {});
      return result;
    },

    // Petició POST a l'Ajax Cart API. Amb «sections» (per defecte) la resposta porta el calaix i la pàgina /cart pintats
    // en l'idioma de la pàgina (sections_url). Amb el país del visitant (Shopify Markets): sense, Shopify feia servir el
    // de la IP (p. ex. Emirats) i podia respondre «ya está agotado» a qui mira la botiga com a Espanya (?country=ES).
    request: function (path, body, options) {
      var payload = Object.assign({}, body);
      if (!options || options.sections !== false) {
        payload.sections = this.sectionIds().join(',');
        payload.sections_url = window.location.pathname;
      }
      var country = window.Shopify && window.Shopify.country;
      return fetch('/' + path + (country ? '?country=' + encodeURIComponent(country) : ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      });
    },

    // Seccions que es tornen a pintar: el calaix i, a /cart, la secció de la pàgina.
    sectionIds: function () {
      var ids = ['cart-drawer'];
      document.querySelectorAll('[data-fb-cart-page][data-section-id]').forEach(function (el) {
        ids.push(el.dataset.sectionId);
      });
      return ids;
    },

    // Torna a pintar la motxilla tal com és ara (sense canviar res): després d'un error o tornant del pagament.
    refresh: function () {
      var self = this;
      return this.run(function () {
        var url = window.location.pathname + '?sections=' + encodeURIComponent(self.sectionIds().join(','));
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (sections) { self.render(sections); });
      });
    },

    resync: function (message) {
      var self = this;
      return this.refresh().catch(function () {}).then(function () { self.showError(message); });
    },

    render: function (sections) {
      if (!sections) return;
      var self = this;
      if (sections['cart-drawer'] && this.root) this.swap(this.root, this.parse(sections['cart-drawer'], '[data-cart-drawer]'));
      document.querySelectorAll('[data-fb-cart-page][data-section-id]').forEach(function (page) {
        var html = sections[page.dataset.sectionId];
        if (html) self.swap(page, self.parse(html, '[data-fb-cart-page]'));
      });
      this.updateCount();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },

    parse: function (html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    },

    // Canvia el contingut d'una motxilla (calaix o pàgina) pel de la resposta, conservant el que l'usuari té entre mans.
    swap: function (current, fresh) {
      if (!current || !fresh) return;
      var open = {};
      current.querySelectorAll('details[data-cart-details]').forEach(function (details) {
        open[details.dataset.cartDetails] = details.open;
      });
      var note = current.querySelector('[data-cart-note]');
      var code = current.querySelector('[data-cart-discount-input]');
      var body = current.querySelector('.cart-drawer__body');
      var scroll = [current.scrollTop, body ? body.scrollTop : 0];
      var focus = this.focusOf(current);

      current.innerHTML = fresh.innerHTML;
      if (fresh.hasAttribute('data-item-count')) current.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));

      current.querySelectorAll('details[data-cart-details]').forEach(function (details) {
        if (open[details.dataset.cartDetails]) details.open = true;
      });
      var newNote = current.querySelector('[data-cart-note]');
      if (note && newNote) newNote.value = note.value;
      var newCode = current.querySelector('[data-cart-discount-input]');
      if (code && newCode) newCode.value = code.value;
      current.scrollTop = scroll[0];
      var newBody = current.querySelector('.cart-drawer__body');
      if (newBody) newBody.scrollTop = scroll[1];
      this.restoreFocus(current, focus);
    },

    // Quin control tenia el focus (per tornar-l'hi després de pintar): l'atribut que el defineix i la línia on és.
    focusOf: function (scope) {
      var el = document.activeElement;
      if (!el || el === scope || !scope.contains(el)) return null;
      var attrs = ['data-quantity-plus', 'data-quantity-minus', 'data-cart-line-input', 'data-cart-remove', 'data-cart-note',
        'data-cart-discount-input', 'data-cart-discount-apply', 'data-cart-upsell-swap', 'data-cart-edition-swap',
        'data-cart-drawer-close'];
      var line = el.closest('[data-cart-line]');
      for (var i = 0; i < attrs.length; i++) {
        if (el.hasAttribute(attrs[i])) return { attr: attrs[i], value: el.getAttribute(attrs[i]), line: line ? line.dataset.key : '' };
      }
      return null;
    },

    restoreFocus: function (scope, focus) {
      if (!focus || !focus.attr) return;
      var target = Array.prototype.filter.call(scope.querySelectorAll('[' + focus.attr + ']'), function (el) {
        var line = el.closest('[data-cart-line]');
        return (line ? line.dataset.key : '') === focus.line && el.getAttribute(focus.attr) === focus.value;
      })[0];
      // Si el control ja no hi és (línia eliminada…), el focus va a la X del calaix.
      if (!target) target = scope.querySelector('[data-cart-drawer-close]');
      if (target) target.focus({ preventScroll: true });
    },

    updateCount: function () {
      var count = this.root && this.root.getAttribute('data-item-count');
      if (count === null || count === undefined) return;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === '0';
      });
    },

    // Missatge d'error: a la web en castellà, el de Shopify quan és concret («El artículo… ya está agotado», amb el mateix
    // text a message i description); si no, el del tema. Els genèrics («Cart Error» / «Cannot find variant») arriben en
    // anglès. En un altre idioma, sempre el del tema (les peticions van sense el prefix de l'idioma: Shopify respon en castellà).
    errorText: function (error, fallback) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var specific = error && error.description && error.message === error.description ? error.description : '';
      return (root === '/' && specific) || fallback || '';
    },

    showError: function (message) {
      if (!message) return;
      document.querySelectorAll('[data-cart-error]').forEach(function (el) {
        el.textContent = message;
        el.hidden = false;
      });
    },

    // Acció en curs: imports atenuats i barra de progrés (fb-cart.css).
    setBusy: function (on) {
      this.busy = Math.max(0, this.busy + (on ? 1 : -1));
      var active = this.busy > 0;
      [this.root, document.querySelector('[data-fb-cart-page]')].forEach(function (el) {
        if (el) el.classList.toggle('is-updating', active);
      });
    },

    // Canvi d'edició o al pack en fila o en camí: «+», «−», «Eliminar» i el camp de quantitat no fan res (atenuats,
    // fb-cart.css), perquè no demanin canvis de línies que el canvi farà desaparèixer.
    setLocked: function (on) {
      this.locked = Math.max(0, this.locked + (on ? 1 : -1));
      var active = this.locked > 0;
      [this.root, document.querySelector('[data-fb-cart-page]')].forEach(function (el) {
        if (el) el.classList.toggle('is-locked', active);
      });
    },

    setLoading: function (on) {
      if (this.root) this.root.classList.toggle('is-loading', on);
    },

    open: function () {
      if (!this.root) return;
      this.root.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.root) return;
      this.root.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    },
  };

  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
  });

  /* ---------------- Cursor glow (Hero) ---------------- */
  var CursorGlow = {
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    fine: function () {
      return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    },
    init: function () {
      if (this.reduced() || !this.fine()) return;
      var glow = document.querySelector('[data-site-glow]');
      if (!glow) return;
      var ticking = false;
      var x = 0, y = 0;
      document.addEventListener('mousemove', function (event) {
        x = event.clientX;
        y = event.clientY;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          glow.style.setProperty('--glow-x', x + 'px');
          glow.style.setProperty('--glow-y', y + 'px');
          glow.classList.add('is-active');
        });
      });
      document.addEventListener('mouseleave', function () {
        glow.classList.remove('is-active');
      });
    },
  };
  CursorGlow.init();

  /* ---------------- Scroll reveal ---------------- */
  var ScrollReveal = {
    selectors: ['.benefit-card', '.upcoming-card', '.library-card', '.faq-item', '.retailers__item', '.pack-extra'],
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    init: function () {
      var elements = document.querySelectorAll(this.selectors.join(','));
      if (!elements.length) return;
      if (this.reduced() || !('IntersectionObserver' in window)) {
        elements.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      elements.forEach(function (el) { el.setAttribute('data-reveal', ''); });
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      elements.forEach(function (el) { observer.observe(el); });
    },
  };
  ScrollReveal.init();

  /* ---------------- Animated star fill (reviews summary) ---------------- */
  var StarFill = {
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    animate: function (stars) {
      var target = stars.dataset.targetPct;
      if (target == null) return;
      if (this.reduced()) {
        stars.style.setProperty('--pct', target + '%');
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          stars.style.setProperty('--pct', target + '%');
        });
      });
    },
    init: function () {
      var self = this;
      var summaryStars = document.querySelector('.reviews-summary__score .review-stars[data-target-pct]');
      if (!summaryStars) return;
      if (!('IntersectionObserver' in window) || this.reduced()) {
        self.animate(summaryStars);
        return;
      }
      summaryStars.style.setProperty('--pct', '0%');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.animate(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.4 });
      observer.observe(summaryStars);
    },
  };
  StarFill.init();

  /* ---------------- Drag to scroll with the mouse (galleries + carousels) ---------------- */
  var DragScroll = {
    selector: '[data-gallery-track], [data-library-track]',

    init: function () {
      var self = this;
      var tracks = document.querySelectorAll(this.selector);
      if (!tracks.length) return;

      var active = null;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      tracks.forEach(function (track) {
        track.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          active = track;
          startX = event.clientX;
          startScroll = track.scrollLeft;
          moved = 0;
          track.classList.add('is-dragging');
        });
      });

      document.addEventListener('pointermove', function (event) {
        if (!active) return;
        var dx = event.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        active.scrollLeft = startScroll - dx;
      });

      function stopDrag() {
        if (!active) return;
        active.classList.remove('is-dragging');
        active = null;
      }
      document.addEventListener('pointerup', stopDrag);
      document.addEventListener('pointercancel', stopDrag);

      document.addEventListener('click', function (event) {
        var track = event.target.closest(self.selector);
        if (track && moved > 5) {
          event.preventDefault();
          event.stopPropagation();
        }
        moved = 0;
      }, true);
    },
  };
  DragScroll.init();

  /* ---------------- Enllaços a una secció de la pàgina (#faq, #pack, #experiencia-digital…) ----------------
     1) A la mateixa pàgina: baixa fins a la secció, just sota la capçalera, sense recarregar la pàgina (encara que
        l'adreça porti paràmetres, p. ex. ?utm_source=… o el ?fbclid=… dels enllaços d'Instagram). La capçalera ja ho fa
        amb els seus enllaços (sections/header.liquid); aquí, la resta: peu, preguntes freqüents, «Previsualizar el pack»…
     2) Arribant d'una altra pàgina amb #secció (peu «Preguntas frecuentes», botó de La Autora…): el navegador hi salta
        mentre encara carreguen les fonts i les imatges, i el contingut de dalt canvia d'alçada; la secció quedava sota
        la capçalera o massa avall. Es torna a alinear quan acaben de carregar i mentre el contingut es mou, sempre que
        el visitant no hagi fet scroll pel seu compte. Mentre la pàgina carrega, el salt és instantani (fb-general.css:
        el desplaçament suau només s'activa amb html.is-ready). */
  var Anchors = {
    reduced: function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },

    // Només seccions visibles: els formularis dins de finestres (#ContactForm, llista d'espera…) tenen el seu propi codi.
    target: function (hash) {
      if (!hash || hash.length < 2) return null;
      var el = null;
      try { el = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (error) { return null; }
      if (!el || el.closest('dialog') || !el.getClientRects().length) return null;
      return el;
    },

    top: function (el) {
      var header = document.querySelector('.site-header');
      var margin = parseFloat(window.getComputedStyle(el).scrollMarginTop) || 0;
      var top = el.getBoundingClientRect().top + window.pageYOffset - (header ? header.offsetHeight : 0) - margin;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      return Math.round(Math.max(0, Math.min(top, max)));
    },

    jump: function (top) {
      var root = document.documentElement;
      var previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, top);
      root.style.scrollBehavior = previous;
    },

    // Recàrrega o Enrere/Endavant: el navegador torna on era el visitant; no l'hem de portar a la secció.
    restoring: function () {
      try {
        var nav = window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
        if (nav) return nav.type === 'reload' || nav.type === 'back_forward';
        return !!(window.performance.navigation && (window.performance.navigation.type === 1 || window.performance.navigation.type === 2));
      } catch (error) { return false; }
    },

    settle: function () {
      var self = this;
      if (this.restoring()) return;
      var el = this.target(window.location.hash);
      if (!el) return;
      var stopped = false;
      var stop = function () { stopped = true; };
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
        window.addEventListener(type, stop, { passive: true, once: true });
      });
      var until = 0;
      var running = false;
      var tick = function () {
        if (stopped) { running = false; return; }
        var top = self.top(el);
        if (Math.abs(window.pageYOffset - top) > 1) self.jump(top);
        if (window.performance.now() < until) window.requestAnimationFrame(tick);
        else running = false;
      };
      var watch = function (ms) {
        until = Math.max(until, window.performance.now() + ms);
        if (!running) { running = true; window.requestAnimationFrame(tick); }
      };
      watch(1500);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { watch(1000); });
      if (document.readyState === 'complete') watch(1000);
      else window.addEventListener('load', function () { watch(1200); });
    },

    init: function () {
      var self = this;
      document.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var link = event.target.closest && event.target.closest('a[href*="#"]');
        if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download') || link.classList.contains('skip-to-content')) return;
        if (!link.hash || link.origin !== window.location.origin || link.pathname !== window.location.pathname) return;
        var el = self.target(link.hash);
        if (!el) return;
        event.preventDefault();
        window.scrollTo({ top: self.top(el), behavior: self.reduced() ? 'auto' : 'smooth' });
        if (window.history && window.history.pushState && window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
      });
      this.settle();
      var ready = function () { document.documentElement.classList.add('is-ready'); };
      if (document.readyState === 'complete') ready();
      else window.addEventListener('load', ready);
    },
  };
  Anchors.init();

  /* ---------------- Botons amb el text en dues línies ----------------
     Quan el text d'un botó no cap en una línia, el navegador li dona tota l'amplada del botó i la fletxa quedava
     a la vora dreta, lluny del text: el conjunt (text + fletxa) es veia descentrat. Aquí el text s'ajusta a l'amplada
     de la seva línia més llarga, i el text i la fletxa queden junts i centrats. Amb una sola línia no es toca res. */
  var ButtonFit = {
    label: function (btn) {
      for (var i = 0; i < btn.children.length; i++) {
        if (btn.children[i].tagName === 'SPAN') return btn.children[i];
      }
      return null;
    },

    fit: function (btn) {
      var label = this.label(btn);
      if (!label || !btn.querySelector('svg')) return;
      label.style.width = '';
      if (!btn.getClientRects().length) return;
      if (window.getComputedStyle(btn).display.indexOf('flex') === -1) return;
      var range = document.createRange();
      range.selectNodeContents(label);
      var rects = range.getClientRects();
      var lines = [];
      for (var r = 0; r < rects.length; r++) {
        var rect = rects[r];
        if (!rect.width) continue;
        var line = null;
        for (var l = 0; l < lines.length; l++) {
          if (Math.abs(lines[l].top - rect.top) < rect.height / 2) { line = lines[l]; break; }
        }
        if (line) {
          line.left = Math.min(line.left, rect.left);
          line.right = Math.max(line.right, rect.right);
        } else {
          lines.push({ top: rect.top, left: rect.left, right: rect.right });
        }
      }
      if (lines.length < 2) return;
      var widest = 0;
      lines.forEach(function (item) { widest = Math.max(widest, item.right - item.left); });
      label.style.width = Math.ceil(widest + 1) + 'px';
    },

    run: function () {
      var self = this;
      document.querySelectorAll('.btn').forEach(function (btn) {
        if (!btn.closest('[data-cart-drawer]')) self.fit(btn);
      });
    },

    init: function () {
      var self = this;
      var timer = null;
      var later = function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { self.run(); }, 120);
      };
      this.run();
      window.addEventListener('resize', later);
      document.addEventListener('pack:change', later);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
      if (document.readyState !== 'complete') window.addEventListener('load', later);
    },
  };
  ButtonFit.init();
})();
